module.exports = __webpack_public_path__ + "img/red_035.26c8e972.png";